<template>
  <div class="news-list">
    <BasePage mode="list">
      <div slot="toolBar">
        <el-row>
          <!-- <div style="float: left">
            <el-button
              v-access:add
              icon="el-icon-plus"
              @click="add"
              size="small"
              :disabled="isloading"
              >新增</el-button
            >
          </div> -->
          <div style="float: right">
            <OfSearch
              @search="search"
              style="float: left; margin-right: 10px"
              :placeholder="placeholder"
            ></OfSearch>
            <el-button
              size="small"
              icon="el-icon-search"
              type="danger"
              @click="loadData"
              >查询</el-button
            >
          </div>
        </el-row>
      </div>
      <div>
        <el-table
          border
          hightlight-current-row
          style="width: 100%"
          :header-cell-class-name="headerRow"
          :data="listData"
          :max-height="tableMaxHeight()"
          v-loading="isloading"
        >
          <el-table-column
            prop="InstationName"
            label="消息流程名称"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="Creator"
            label="创建人"
            align="center"
            width="120"
          ></el-table-column>
          <el-table-column label="创建时间" align="center" width="100">
            <template slot-scope="scope">
              {{ (scope.row.CreateTime * 1000) | formatDate2 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="Modifier"
            label="修改人"
            align="center"
            width="120"
          ></el-table-column>
          <el-table-column label="修改时间" align="center" width="100">
            <template slot-scope="scope">
              {{ (scope.row.ModifyTime * 1000) | formatDate2 }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button
                v-access:modify
                @click="innerEdit(scope.row)"
                type="text"
                size="mini"
                >编辑</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wapper">
          <OfPagination
            :total="total"
            :pageSize="pageSize"
            :currentPage="currentPage"
            @onSizeChange="handleSizeChange"
            @onCurrentChange="handleCurrentChange"
          ></OfPagination>
        </div>
      </div>
    </BasePage>
    <ModuleEdit
      v-if="formVisible"
      :dataForm="formData"
      :formTitle="formTitle"
      @formCallBack="formCallBack"
    ></ModuleEdit>
  </div>
</template>

<script>
import BasePage from "@/components/base/of_page/of_page";
import OfSearch from "@/components/controls/of_search/of_search";
import ModuleEdit from "@/modules/zjrc/pages/basics/approvalprocess/instationSet/edit";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import { mapGetters } from "vuex";
import api from "@/modules/zjrc/api";

export default {
  name: "list",
  data() {
    return {
      isloading: false,
      listData: [],
      headerRow: "header-row",
      formVisible: false,
      formDataQuery: false,
      formTitle: "",
      formData: {},
      total: 0,
      currentPage: 1,
      pageSize: 15,
      searchModel: {},
      placeholder: "消息流程名称 / 创建人 / 修改人",
    };
  },
  filters: {
    rounding(value) {
      return value.toFixed(2);
    },
  },
  methods: {
    //初始化数据
    loadData(TypeId) {
      this.isloading = true;
      let params = {
        PageIndex: this.currentPage,
        PageSize: this.pageSize,
        SearchKey:
          this.searchModel.searchKey == null ? "" : this.searchModel.searchKey,
      };
      api.queryStationSet(params).then((rep) => {
        if (rep.data.Code === 0) {
          this.total = rep.data.Data.total;
          this.listData = rep.data.Data.rows;
        }
        this.isloading = false;
      });
    },
    //按钮搜索
    btnQuery() {
      this.searchModel.projectName = this.projectName;
      this.loadData();
    },
    //新增
    add() {
      this.formTitle = "新增消息设置";
      this.formData = {};
      this.formVisible = true;
      this.formData.Creator = this.GetCurrentUserInfo.RealName;
      this.formData.CreatorId = this.GetCurrentUserInfo.Id;
    },
    //关键字查找
    search(keyword) {
      this.searchModel.searchKey = keyword;
      this.loadData();
    },
    innerEdit(rowData) {
      this.formData = Object.assign({}, rowData);
      this.edit();
    },
    edit() {
      (this.formTitle = "编辑消息设置"), (this.formVisible = true);
    },
    //回调
    formCallBack(data) {
      this.formVisible = false;
      this.formDataQuery = false;
      if (data != null) {
        this.loadData();
      }
    },
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.loadData();
    },
    handleCurrentChange(val) {
      if (this.total > this.pageSize) {
        this.currentPage = val;
        this.loadData();
      }
    },
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 250;
      }
      return tableMaxHeight;
    },
  },
  components: {
    BasePage,
    OfSearch,
    OfPagination,
    ModuleEdit
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"]),
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style scoped>
.el-date-editor >>> .el-input__icon {
  display: none;
}

/* .el-select >>> .el-input__inner {
  width: 120px;
} */
</style>

<style >
.searchbox {
  float: left;
  margin-right: 1%;
}
.searchbox_right {
  float: right;
  margin-right: 1%;
  widows: 100%;
}
</style>
